module.exports = __webpack_public_path__ + "img/chongzhi.bd42f644.svg";